import { render } from "./MediaContact.vue?vue&type=template&id=2007ecff&scoped=true"
import script from "./MediaContact.vue?vue&type=script&lang=js"
export * from "./MediaContact.vue?vue&type=script&lang=js"

import "./MediaContact.vue?vue&type=style&index=0&id=2007ecff&scoped=true&lang=css"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2007ecff"]])

export default __exports__